export const FILTER_DROPDOWN_MIN_WIDTH = '240px';
